function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_209",
  "data-name": "Group 209",
  transform: "translate(-4556.979 -651.479)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M10.794,5.4,8.635,7.556,5.4,4.318,2.159,7.556,0,5.4,5.4,0Z",
  transform: "translate(4584.525 671.934) rotate(135)",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M10.794,5.4,8.635,7.556,5.4,4.318,2.159,7.556,0,5.4,5.4,0Z",
  transform: "translate(4556.979 659.112) rotate(-45)",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M10.794,5.4,8.635,7.556,5.4,4.318,2.159,7.556,0,5.4,5.4,0Z",
  transform: "translate(4564.611 679.566) rotate(-135)",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-4",
  "data-name": "Path",
  d: "M10.794,5.4,8.635,7.556,5.4,4.318,2.159,7.556,0,5.4,5.4,0Z",
  transform: "translate(4576.893 651.479) rotate(45)",
  fill: "current"
}));

function SvgFullscreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.547,
    height: 28.087,
    viewBox: "0 0 27.547 28.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.1084a3d9.svg";
export { ForwardRef as ReactComponent };